<!-- Template library card -->
<app-card [containerClasses]="['template-library-container']"
  [contextMenuItems]="sortOptions"
  (clickedItem)="updatePieceSortOption($event)">
  <ng-container card-title>{{'TEMPLATE_LIBRARY' | translate}}</ng-container>
  <ng-container card-body>
    <ng-container *ngTemplateOutlet="templateLibraryTemplate"></ng-container>
  </ng-container>
</app-card>
<!-- End of Template library card -->

<!-- Templates section -->
<ng-template #templateLibraryTemplate>
  <mat-form-field class="search-field"
    appearance="outline"
    [style.width.%]="100">
    <label class="visually-hidden" for="template-library-search-input">{{'SEARCH_PLACEHOLDER' | translate}}</label>
    <input matInput
      id="template-library-search-input"
      type="text"
      placeholder="{{'SEARCH_PLACEHOLDER' | translate}}"
      [formControl]="searchControl">
    <mat-icon matPrefix class="mat-icon-rtl-mirror search-icon">search</mat-icon>
    <button *ngIf="searchControl.value.length > 0"
      mat-icon-button
      type="button"
      matSuffix
      class="close-icon"
      aria-label="Clear search"
      (click)="clearSearch()">
      <mat-icon class="mat-icon-rtl-mirror">close</mat-icon>
    </button>
  </mat-form-field>
  <ng-container *appLoadingSpinner="shouldLoading$ | async; diameter: 100">
    <app-template-library-tree
      [templateLibraryData]="(blankConfigurationPiece$ | async).concat((configurationPieces$ | async))"
      [languageDictionary]="languageDictionary$ | async"
      [isMenuHidden]="!(isAccessGranted$ | async)"
      (shouldReloadPieces)="reloadTemplateLibraryPieces()"></app-template-library-tree>
  </ng-container>
</ng-template>
<!-- End of templates section -->
